import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language.startsWith('zh') ? 'zh-CN' : 'en';

  // 在组件挂载时检查并恢复保存的语言设置
  useEffect(() => {
    const savedLang = localStorage.getItem('i18nextLng');
    if (savedLang && savedLang !== i18n.language) {
      i18n.changeLanguage(savedLang);
    }
  }, []);

  const toggleLanguage = () => {
    const nextLang = currentLang === 'en' ? 'zh-CN' : 'en';
    // 切换语言
    i18n.changeLanguage(nextLang);
    // 手动存储在localStorage中，确保持久化
    localStorage.setItem('i18nextLng', nextLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className={`
        px-3 py-1 rounded-md text-sm font-medium transition-colors
        ${currentLang === 'en' 
          ? 'text-neutral-700 hover:text-neutral-900 hover:bg-neutral-100' 
          : 'text-primary-600 hover:text-primary-700 hover:bg-primary-50'
        }
      `}
      aria-label="Toggle language"
    >
      {currentLang === 'en' ? '中文' : 'EN'}
    </button>
  );
};
